module.exports = __webpack_public_path__ + "static/img/12.b448371.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/12.png
// module id = 2dx4
// module chunks = 0